import { AxiosService } from './../../../services/axios.service'
import * as config from 'config'

const topics = () => AxiosService.get(`faq/topicos`)

export { topics }
